import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleGrid from "./components/ArticleGrid";
import HotSidebar from "./components/HotSidebar";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";
import Footer from "@/components/feature/Footer";
import { faqItems } from "@/mocks/articles";

const siteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "911吃瓜网",
  url: "https://911chigua.com",
  description:
    "911吃瓜网最新地址发布页，提供911吃瓜网站、911吃瓜网app下载入口。每日更新网红翻车、明星黑料、社会热点爆料，独家吃瓜资源一站获取。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://911chigua.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "911吃瓜网",
  url: "https://911chigua.com",
  description:
    "911吃瓜网 - 每日更新网红翻车、明星黑料、社会热点爆料的专业吃瓜平台",
  sameAs: ["https://weibo.com/911chigua", "https://t.me/chigua911"],
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "911吃瓜网 - 网红翻车明星黑料每日更新",
  description:
    "911吃瓜网最新地址发布页，提供911吃瓜网站、911吃瓜网app下载入口。每日更新网红翻车、明星黑料、社会热点爆料。",
  url: "https://911chigua.com",
  isPartOf: { "@type": "WebSite", name: "911吃瓜网", url: "https://911chigua.com" },
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "首页", item: "https://911chigua.com" },
  ],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="911吃瓜网 - 911吃瓜网站与911吃瓜网最新地址 | 网红翻车明星黑料每日更新"
        description="911吃瓜网最新地址发布页，提供911吃瓜网站、911吃瓜网app下载入口。每日更新网红翻车、明星黑料、社会热点爆料，独家吃瓜资源一站获取，随时随地看最新大瓜。"
        keywords="911吃瓜网,911吃瓜网站,911吃瓜网最新地址,911吃瓜网app,网红翻车,明星黑料,每日爆料,911吃瓜爆料,911吃瓜黑料,吃瓜网"
        canonicalUrl="https://911chigua.com"
        schemaData={[siteSchema, orgSchema, webPageSchema, breadcrumbSchema, faqSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleGrid />
        <HotSidebar />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}